var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 56,
    viewBox: "0 0 65 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1597_42592)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3719 38.2192C62.8481 38.2192 64.8554 36.1599 64.8554 33.6197C64.8554 31.0795 62.8481 29.0203 60.3719 29.0203C57.8957 29.0203 55.8884 31.0795 55.8884 33.6197C55.8884 36.1599 57.8957 38.2192 60.3719 38.2192Z",
    fill: "#95C3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1218 38.5073C62.598 38.5073 64.6054 36.448 64.6054 33.9078C64.6054 31.3676 62.598 29.3083 60.1218 29.3083C57.6457 29.3083 55.6383 31.3676 55.6383 33.9078C55.6383 36.448 57.6457 38.5073 60.1218 38.5073Z",
    fill: "#95C3FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.1739 27.8944C22.6821 27.8944 28.7687 21.65 28.7687 13.9472C28.7687 6.24437 22.6821 0 15.1739 0C7.6657 0 1.5791 6.24437 1.5791 13.9472C1.5791 21.65 7.6657 27.8944 15.1739 27.8944Z",
    fill: "#75B2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4101 28.7658C21.9183 28.7658 28.0049 22.5215 28.0049 14.8186C28.0049 7.11583 21.9183 0.87146 14.4101 0.87146C6.9019 0.87146 0.815308 7.11583 0.815308 14.8186C0.815308 22.5215 6.9019 28.7658 14.4101 28.7658Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1891 48.5943H17.9473C17.0935 48.5943 16.2479 48.4151 15.4591 48.0669C14.6702 47.7188 13.9533 47.2084 13.3495 46.5651C12.7457 45.9218 12.2668 45.1581 11.9401 44.3175C11.6133 43.477 11.4451 42.5761 11.4451 41.6663V14.6865C11.4475 12.8506 12.1335 11.0906 13.3526 9.79306C14.5717 8.4955 16.2242 7.76638 17.9473 7.76575H46.1891C49.7804 7.76575 52.6913 12.1491 52.6913 14.6961V41.6663C52.6913 42.5761 52.5232 43.477 52.1964 44.3175C51.8696 45.1581 51.3907 45.9218 50.7869 46.5651C50.1831 47.2084 49.4663 47.7188 48.6774 48.0669C47.8885 48.4151 47.0429 48.5943 46.1891 48.5943Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8621 9.12683H16.6181C13.027 9.12683 10.1158 12.2286 10.1158 16.0548V43.037C10.1158 46.8632 13.027 49.965 16.6181 49.965H44.8621C48.4532 49.965 51.3643 46.8632 51.3643 43.037V16.0548C51.3643 12.2286 48.4532 9.12683 44.8621 9.12683Z",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1806 21.5953H44.9409C41.3498 21.5953 38.4387 24.6971 38.4387 28.5233V36.69C38.4387 40.5162 41.3498 43.618 44.9409 43.618H54.1806C57.7717 43.618 60.6828 40.5162 60.6828 36.69V28.5233C60.6828 24.6971 57.7717 21.5953 54.1806 21.5953Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7348 22.7524H41.7731C39.2099 22.7524 37.1319 24.9665 37.1319 27.6976V39.8299C37.1319 42.5611 39.2099 44.7751 41.7731 44.7751H54.7348C57.2981 44.7751 59.3761 42.5611 59.3761 39.8299V27.6976C59.3761 24.9665 57.2981 22.7524 54.7348 22.7524Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1319 16.7462H14.926V17.7977H37.1319V16.7462Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0671 19.9005H14.926V20.952H32.0671V19.9005Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0671 24.1063H14.926V25.1578H32.0671V24.1063Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1319 38.296H14.926V39.3474H37.1319V38.296Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5279 36.4644H40.9824V37.5158H55.5279V36.4644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5437 39.5515H40.9981V40.6029H55.5437V39.5515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5428 14.6938C58.0783 13.6472 55.8726 13.0278 55.3004 14.0048C54.8497 14.7922 55.5392 16.4342 56.6004 17.4856C57.7269 18.6067 58.5987 18.381 60.3246 19.7782C61.8499 21.0144 62.2284 22.0467 62.5776 22.0803C63.3346 22.1523 62.8007 17.0271 59.5428 14.6938Z",
    fill: "#95C3FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.4106 33.8381L48.0208 34.3182C47.9956 34.3497 47.9647 34.3756 47.93 34.3942C47.8952 34.4129 47.8574 34.424 47.8186 34.4269C47.7798 34.4298 47.7408 34.4245 47.7039 34.4112C47.6671 34.3979 47.6331 34.3769 47.604 34.3494L44.1298 31.0799C44.0708 31.024 44.0348 30.9457 44.0293 30.8618C44.0238 30.7779 44.0494 30.695 44.1006 30.631L44.4926 30.1509C44.518 30.1195 44.549 30.0938 44.5838 30.0754C44.6186 30.0569 44.6565 30.0461 44.6953 30.0434C44.7341 30.0407 44.773 30.0463 44.8098 30.0598C44.8465 30.0733 44.8804 30.0945 44.9094 30.122L48.3903 33.3916C48.4479 33.4484 48.4822 33.5269 48.486 33.6104C48.4898 33.6939 48.4627 33.7756 48.4106 33.8381Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1356 26.8646C54.3451 27.0878 54.3451 27.4503 54.0297 27.9136C54.0263 27.9221 54.0209 27.9296 54.0139 27.9352L48.1853 34.1934C48.1684 34.2116 48.1479 34.2256 48.1253 34.2343C48.1027 34.243 48.0786 34.2463 48.0546 34.2438C47.844 34.2345 47.6424 34.1499 47.4823 34.0038C47.3816 33.8951 47.3252 33.7484 47.3252 33.5957C47.3252 33.4429 47.3816 33.2963 47.4823 33.1876L53.3673 26.8646C53.4171 26.8096 53.4768 26.7659 53.5428 26.736C53.6088 26.7062 53.6797 26.6908 53.7514 26.6908C53.8231 26.6908 53.8941 26.7062 53.9601 26.736C54.0261 26.7659 54.0858 26.8096 54.1356 26.8646Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M10.0482 51.0429C10.5106 51.3006 10.9903 51.5213 11.4834 51.703C11.9949 51.8855 12.2382 51.8951 12.6572 52.0295C14.0091 52.4664 14.7526 52.7137 15.1942 53.3234C15.6358 53.9331 15.5276 55.1334 14.9868 55.6639C14.1938 56.4345 12.6144 55.6975 11.6321 55.239C10.7598 54.8335 9.95776 54.2743 9.25966 53.585C6.14146 50.4283 4.48997 44.9239 4.79188 44.7774C5.09378 44.631 8.36746 50.0827 10.0482 51.0429Z",
    fill: "#95C3FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1597_42592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.0402,
    height: 56,
    fill: "white",
    transform: "translate(0.815308)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessDoc);
export default __webpack_public_path__ + "static/media/SuccessDoc.6604e131e7bfcb24bcd6e31b6bd03eeb.svg";
export { ForwardRef as ReactComponent };